(function () {
	'use strict';

	const modules = [];

	angular.module('DatablockModule', modules);
})();
